import { render, staticRenderFns } from "./borelogSidePanel.vue?vue&type=template&id=118aeba1&scoped=true"
import script from "./borelogSidePanel.vue?vue&type=script&lang=js"
export * from "./borelogSidePanel.vue?vue&type=script&lang=js"
import style0 from "./borelogSidePanel.vue?vue&type=style&index=0&id=118aeba1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118aeba1",
  null
  
)

export default component.exports